export default function sanitizeQueryObject (query = {}, allowStrings = []) {
  return Object.keys(query).filter(key => allowStrings.includes(key)).reduce((prev, cur) => {
    if (query[cur] !== "") { prev[cur] = query[cur]; }
    return prev;
  }, {});
}
